const prodPresencial = [
    '007800020',
    '007810030',
    '014120001'
]

export default prodPresencial